import { styled } from '@linaria/react';

export const SubsectionTitle = styled.h4`
    font-size: 1.1rem;
    font-weight: bold;
    margin-top: 1.5rem;
    margin-bottom: 1rem;
    color: #333;

    &:first-of-type {
        margin-top: 0;
    }
`;

export const StowageRulesTable = styled.table`
    width: 100%;
    border-collapse: collapse;
    margin-bottom: 1.5rem;
`;

export const StowageRuleRow = styled.tr`
    border-bottom: 1px solid #dee2e6;

    &:last-child {
        border-bottom: none;
    }

    td {
        padding: 0.75rem 0.5rem;
    }
`;

export const EditSelect = styled.select`
    padding: 0.4rem 0.5rem;
    border: 1px solid #cbd5e1;
    border-radius: 4px;
    font-size: 0.875rem;
    min-width: 260px;

    &:focus {
        outline: none;
        border-color: #2563eb;
        box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.2);
    }
`;

export const RemoveRuleButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    padding: 0.25rem;
    opacity: 0.7;

    &:hover {
        opacity: 1;
    }
`;

export const StowageRuleLink = styled.a`
    color: #007bff;
    text-decoration: none;
    font-size: 0.95rem;

    &:hover {
        text-decoration: underline;
        color: #0056b3;
    }
`;

export const NoRulesMessage = styled.p`
    font-style: italic;
    color: #6c757d;
    margin-bottom: 1.5rem;
`;

export const NoticeBox = styled.div`
    background-color: #fff3cd;
    border: 1px solid #ffc107;
    border-radius: 4px;
    padding: 1rem;
    margin-top: 2rem;
    font-size: 0.9rem;
    color: #856404;

    strong {
        font-weight: 600;
    }
`;
